define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"csi/xml"
], function(declare,Widget,xml) {
	
	return declare(Widget, {
		onActionDelete: function(/*Controller*/ac, /*CallMethod?*/call) {
			// summary: add store name as parameter to delete request
			call.addParameter("Name", xml.ATTR_STRING, ac.getNode().$Name);
		}
	});
});